import { computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import Decimal from "decimal.js";
import { queries } from "@erp/shared/queries";
/**
 * @decription - 노무비 정보애서 특정 프로퍼티 추출
 * @param laborList - 노무비 정보 리스트
 * @param laborOccupationList - 직종별 설계조정률, 단가 리스트
 */
export const useLaborCostLookup = () => {
    const { data: laborList } = useQuery(queries.laborCost.laborCostCalc());
    const { data: laborOccupationList } = useQuery(queries.laborCost.marketWageUnitPrice());
    const names = computed(() => laborList.value?.map((x) => x.name) ?? []);
    /** 노무비 산출 정보에서 규격 리스트 추출 */
    function typesFor(item) {
        return (laborList.value?.filter((x) => x.name === item.name).map((x) => x.type) ??
            []);
    }
    /** 노무비 산출 정보에서 직종 리스트 추출 */
    function occupationsFor(item) {
        const occs = laborList.value
            ?.filter((x) => x.name === item.name && x.type === item.type)
            .map((x) => x.occupation);
        return occs?.includes("ALL")
            ? (laborOccupationList.value?.map((o) => o.occupation) ?? [])
            : (occs ?? []);
    }
    /** 노무비 리스트에서 특정 데이터 추출 */
    function matchLabor(item) {
        return (laborList.value?.find((x) => x.name === item.name &&
            x.type === item.type &&
            (x.occupation === item.occupation || x.occupation === "ALL")) || null);
    }
    function matchLaborOccupation(item) {
        return (laborOccupationList.value?.find((x) => x.occupation === item.occupation) || null);
    }
    /** get 품번 */
    function getNo(item) {
        console.log("getNo", item);
        return matchLabor(item)?.no ?? "";
    }
    /** get 공량(M/D) */
    function getManPerDay(item) {
        return matchLabor(item)?.manPerDay ?? 0;
    }
    /** get 할증률 */
    function getSurcharge(item) {
        return matchLabor(item)?.surchargeRatio ?? 0;
    }
    /** get 설계조정률 */
    function getAdjustment(item) {
        return matchLaborOccupation(item)?.adjustmentRatio ?? 0;
    }
    /** get 공량(M/H) = 공량(M/D) * 할증률 * 설계조정률 */
    function getManHour(item) {
        const m = matchLabor(item);
        const adj = matchLaborOccupation(item)?.adjustmentRatio;
        if (!m || adj == null)
            return 0;
        const manPerDay = new Decimal(m.manPerDay);
        const surchargeRatio = new Decimal(m.surchargeRatio);
        const adjustmentRatio = new Decimal(adj);
        const result = manPerDay
            .mul(surchargeRatio)
            .mul(adjustmentRatio)
            .toDecimalPlaces(3); // 소수점 3자리까지
        return result.toNumber();
    }
    /** get 단가 */
    function getUnitPrice(item) {
        const occ = matchLaborOccupation(item);
        return occ ? occ.unitPrice : 0;
    }
    /** get 금액 = 공량(M/H) * 단가 * 수량 */
    function getTotalAmount(item) {
        const hour = getManHour(item);
        const occ = matchLaborOccupation(item);
        if (!hour || !occ)
            return 0;
        const manHour = new Decimal(hour);
        const unitPrice = new Decimal(occ.unitPrice);
        const quantity = new Decimal(item.quantity ?? 1);
        const result = manHour.mul(unitPrice).mul(quantity).toDecimalPlaces(0); // 정수로 반올림
        return result.toNumber();
    }
    /** 직종 설정 시 단가, 설계조정률, 공량(M/H) 적용 */
    // function onOccupationChange(item: LaborCostEntry, occupation: string): void {
    //   laborOccupationList.value.forEach((i) => {
    //     if (occupation === i.name) {
    //       item.unit_price = i.unit_price;
    //       item.adjustment_ratio = i.adjustment_ratio;
    //       item.man_per_hour = parseFloat(
    //         (
    //           item.man_per_day *
    //           item.surcharge_ratio *
    //           item.adjustment_ratio
    //         ).toFixed(3)
    //       );
    //     }
    //   });
    // }
    const loading = computed(() => {
        return (laborList.value === undefined || laborOccupationList.value === undefined);
    });
    return {
        names,
        typesFor,
        occupationsFor,
        matchLabor,
        matchLaborOccupation,
        getNo,
        getManPerDay,
        getSurcharge,
        getAdjustment,
        getManHour,
        getUnitPrice,
        getTotalAmount,
        // onOccupationChange,
        loading,
    };
};
